import {
  ComponentFactoryResolver,
  Directive,
  ElementRef,
  EventEmitter,
  HostListener, Input, Output, ViewContainerRef } from '@angular/core';
import { FormControlName, NgModel } from '@angular/forms';
import { ClearComponent } from './clear.component';
import { ClearIconSharedService } from './clearIcon.sharedService';

@Directive({
  selector: '[axis-input-clear]'
})
export class ClearInputDirective {
  public showClear = false;
  public clearCompRef: any;
  public compRefClicked = false;
  public isKeyPressed = false;
  @Input() public isMobileReadOnly = false;

  @Output() onClear = new EventEmitter();
  @Output() onTouchedEvent = new EventEmitter();

  constructor(
    private viewContainerRef: ViewContainerRef,
    private resolver: ComponentFactoryResolver,
    private model: NgModel,
    private formControlName: FormControlName,
    private el: ElementRef,
    private clearIconSharedService: ClearIconSharedService
  ) {}

  @HostListener('focus')
  onFocusHandler() {
    if (this.el.nativeElement.value && (!this.el.nativeElement.readOnly || this.isMobileReadOnly)) {
      this.showClear = true;
      this.enableClear();
      this.loadClearInput(this.el.nativeElement.value);
    }
  }

  @HostListener('blur')
  onBlurHandler() {
    if (!this.compRefClicked) {
      this.disableClearIcon();
    }
    this.compRefClicked = false;
    this.el.nativeElement.classList.remove('axis-input-padding');
  }
  loadClearInput(value) {
    if (value) {
      this.disableClearIcon(); // Making sure no double instances of dynamic components
      this.showClear = true;
      this.enableClear();
    } else {
      if (this.showClear) {
        this.disableClearIcon();
      }
    }
  }


  @HostListener('keydown', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    const target = (event.target as HTMLInputElement).value;
    if (event.key === 'Escape' || event.key === 'Esc') {
      this.clearInputValue();
      this.el.nativeElement.blur();
    }
    if (!this.el.nativeElement.readOnly && target !== '') {
      this.loadClearInput(target.toString());
    }
    this.isKeyPressed = true;
  }

  @HostListener('input', ['$event.target'])
  onKeyPress(data: any): void {
    // internet explorer cross icon issue is fixed
    if (navigator.userAgent.indexOf('Trident') !== -1 && navigator.userAgent.indexOf('MSIE') === -1) {
     if (!this.el.nativeElement.readOnly && this.isKeyPressed === true) {
        this.loadClearInput(data.value.toString());
        this.isKeyPressed = false;
      }
    } else if (!this.el.nativeElement.readOnly && (data.value === '' || data.value.length >= 1)) {
      this.loadClearInput(data.value.toString());
    }
  }

  enableClear() {
    this.checkParentClass(this.el.nativeElement, 3);
    this.el.nativeElement.classList.add('axis-input-padding');
    const key = this.clearIconSharedService.generateUniqueKey();
    this.clearIconSharedService.setInstance(this, key);
    const clearCompFactory = this.resolver.resolveComponentFactory(
      ClearComponent
    );
    this.clearCompRef = this.viewContainerRef.createComponent(clearCompFactory);
    this.clearCompRef.instance.uniqueKey = key;
    this.clearCompRef.instance.isdisabled = this.el.nativeElement.disabled;
  }
  clearInputValue() {
    this.el.nativeElement.classList.remove('axis-input-padding');
    this.disableClearIcon();
    if (this.formControlName && this.formControlName.control) {
      this.formControlName.control.setValue('');
    } else {
      this.el.nativeElement.value = '';
    }
    this.model.reset();
    this.onClear.emit();
    setTimeout(() => {
      this.el.nativeElement.focus();
    }, 0);
    this.el.nativeElement.blur(); // internet explorer cross icon issue is fixed when input is entered or pasted
  }
  disableClearIcon() {
    this.showClear = false;
    if (this.clearCompRef) {
      this.clearCompRef.destroy();
      this.clearCompRef = null;
    }
  }
  checkParentClass(parent, level) {
    if (level > 0) {
      if (parent.parentNode.classList.contains('axis-form-group')) {
        if (!parent.parentNode.classList.contains('has-input-clear')) {
          parent.parentNode.classList.add('has-input-clear');
        }
      } else {
        this.checkParentClass(parent.parentNode, level - 1);
      }
    } else {
      return;
    }
  }
}
